<template>
  <gw-listing class="a7-cidade-listing" :refresh="refresh" :title="$t('Cidade')"
  :default-filter-params="defaultFilterParams" modal-size="small"
  :entity-dto-rest-resource="entityDTORestResource"
  :presentation="presentation"
  >
    <gw-column field="nome"/>
    <gw-column field="estado"/>
    <gw-column field="codigoIBGE"/>

    <template slot="filterBand">
      <gw-text-filter-item :display-text="$t('Cidade.ui.filtroNome')"
        property-name="nome"/>
      <a7-estado-filter-item :display-text="$t('Cidade.ui.filtroEstado')"
        property-name="estado"/>
    </template>

    <template slot="editor">
      <gw-grouping-pane :title="$t('Global.ui.detalhes')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="nome" class="gw-col-6"/>
            <gw-editor-field property="estado" class="gw-col-6">
              <a7-estado-entity-chooser slot-scope="{ entity, properties }"
              v-model="entity.estado"
              v-bind="properties"
              />
             </gw-editor-field>
          </div>
          <div class="gw-row">
            <gw-editor-field property="codigoIBGE" class="gw-col-12" showDescription/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
    </template>

  </gw-listing>
</template>

<script>
/**
 * @references
 *  UI0008
*/
import {
  GwListing,
  GwTextFilterItem,
  GwColumn,
  GwEditorField,
  GwGroupingPane,
  GwGridContainer,
  FilterUtilities,
  GwEntityChooser
} from "guaxinim-web";
import CidadeRestResource from './CidadeRestResource'
import A7EstadoFilterItem from '../estado/A7EstadoFilterItem'
import A7EstadoEntityChooser from '../estado/A7EstadoEntityChooser'

export default {
  name: "a7-cidade-listing",
  components: {
    GwListing,
    GwTextFilterItem,
    GwColumn,
    GwEditorField,
    GwGroupingPane,
    GwGridContainer,
    A7EstadoFilterItem,
    A7EstadoEntityChooser
  },
  props: {
    defaultFilterParams: {
      type: Object
    },
  },
  data() {
    return {
      entityDTORestResource: CidadeRestResource,
      presentation: null
    }
  },
  methods: {
    refresh(filterParams) {
      return this.entityDTORestResource.findDTOs(null,
        FilterUtilities.createFilterParamsString(filterParams));
    },
    search(pattern) {
      return this.entityDTORestResource.findCidadeFinderDTO(null, pattern, 10);
    },
    findEntityByID(id) {
      return this.entityDTORestResource.findCidadeFinderDTOByID(id);
    }
  },
  created() {
    this.entityDTORestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
  }
};
</script>

<style lang="scss" scoped>
</style>